import { render } from "./CreateRoom.vue?vue&type=template&id=6253bf7d&scoped=true"
import script from "./CreateRoom.vue?vue&type=script&lang=js"
export * from "./CreateRoom.vue?vue&type=script&lang=js"

import "./CreateRoom.vue?vue&type=style&index=0&id=6253bf7d&scoped=true&lang=css"

import exportComponent from "C:\\Source\\vueChatApp-main\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6253bf7d"]])

export default __exports__